var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFilters = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.667 14.5v-4m0 0C3.403 10.5 4 9.903 4 9.167V7.833C4 7.097 3.403 6.5 2.667 6.5m0 4a1.333 1.333 0 0 1-1.334-1.333V7.833c0-.736.597-1.333 1.334-1.333M8 14.5V9.833m0-6V2.5m0 1.333c.736 0 1.333.597 1.333 1.334V6.5a1.333 1.333 0 1 1-2.666 0V5.167c0-.737.597-1.334 1.333-1.334ZM2.667 6.5v-4m10.666 4.667V2.5m0 12v-1.333m0 0c.737 0 1.334-.597 1.334-1.334V10.5a1.333 1.333 0 1 0-2.667 0v1.333c0 .737.597 1.334 1.333 1.334Z",
  stroke: "#AAADB6",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));
export default SvgFilters;